/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Frame_LoadingInputs */

const en_cookie_frame_loading = /** @type {(inputs: Cookie_Frame_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading content…`)
};

const lv_cookie_frame_loading = /** @type {(inputs: Cookie_Frame_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ielādē saturu…`)
};

/**
* | output |
* | --- |
* | "Loading content…" |
*
* @param {Cookie_Frame_LoadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_frame_loading = /** @type {((inputs?: Cookie_Frame_LoadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Frame_LoadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_frame_loading(inputs)
	return en_cookie_frame_loading(inputs)
});